import { render, staticRenderFns } from "./CourierMap.vue?vue&type=template&id=decd1316&scoped=true&"
import script from "./CourierMap.vue?vue&type=script&lang=js&"
export * from "./CourierMap.vue?vue&type=script&lang=js&"
import style0 from "./CourierMap.vue?vue&type=style&index=0&id=decd1316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decd1316",
  null
  
)

export default component.exports